// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PaymentElementShimmer$OrcaPaymentPage from "./PaymentElementShimmer.bs.js";

function WalletShimmer(props) {
  return React.createElement(PaymentElementShimmer$OrcaPaymentPage.Shimmer.make, {
              children: React.createElement("div", {
                    className: "animate-pulse w-full h-12 rounded bg-slate-200 flex justify-center items-center "
                  }, React.createElement("div", {
                        className: "w-24 h-3 rounded bg-white bg-opacity-70 self-center "
                      })),
              classname: "opacity-70"
            });
}

var make = WalletShimmer;

export {
  make ,
}
/* react Not a pure module */
